export function mapSeasonsToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.saison_id ?? s.saisonId ?? s.id ?? null;
    const value = (s.kuerzel ?? s.value ?? '') + ''; // string
    const text = s.name ?? s.text ?? '';
    const order = s.reihenfolge ?? s.order ?? 0;

    return { key, value, text, order };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function map3lcToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.zgbid ?? null;
    const value = s.name ?? s.text ?? '';
    const text = s.name ?? s.text ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapHotelchainToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.hotelkette_id ?? null;
    const value = s.hotelkette_id ?? null;
    const text = s.hotelkette_name ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapAgencyToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.id ?? null;
    const value = s.code ?? null;
    const text = s.vertreter ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapCategoryToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.kategorie_sterne ?? null;
    const value = s.kategorie_sterne ?? null;
    const text = s.kategorie_name ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapCategoryTOToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.kategorie_sterne ?? null;
    const value = s.kategorie_sterne ?? null;
    const text = s.kategorie_name ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapHoteltypeToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.hoteltyp_id ?? null;
    const value = s.hoteltyp_id ?? null;
    const text = s.hoteltyp_name ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapBoardToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.id ?? null;
    const value = s.verpfl_abk ?? null;
    const text = s.verpfl_name ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapRoomsToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.id ?? null;
    const value = s.zimmerart_name_eng ?? null;
    const text = s.zimmerart_name ?? '';
    
    return { key, value, text };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export function mapCurrencyToOptions(values) {
  if (!Array.isArray(values)) return [];

  const mapped = values.map(s => {
    const key = s.id ?? null;
    const value = s.id ?? null;
    const text = s.name ?? '';
    const code = s.kuerzel ?? '';
    
    return { key, value, text, code };
  }).filter(item => item.key !== null && item.text !== '');
  
  return mapped;
}



export const optionsSeason = [
  { key: 59, value: '26',   text: '2026',         order: 129 },
  { key: 58, value: 'S25',  text: 'Sommer 2025',  order: 128 },
  { key: 57, value: '25',   text: '2025',         order: 126 },
  { key: 56, value: 'W24',  text: 'Winter 24/25', order: 125 },
  { key: 55, value: 'S24',  text: 'Sommer 2024',  order: 124 },
  { key: 54, value: '24',   text: '2024',         order: 123 },
  { key: 53, value: 'W23',  text: 'Winter 23/24', order: 122 },
  { key: 52, value: 'S23',  text: 'Sommer 2023',  order: 121 },
  { key: 51, value: '23',   text: '2023',         order: 120 },
  { key: 50, value: 'W22',  text: 'Winter 22/23', order: 117 },
  { key: 49, value: 'S22',  text: 'Sommer 2022',  order: 116 },
  { key: 48, value: '22',   text: '2022',         order: 115 },
  { key: 47, value: 'W21',  text: 'Winter 21/22', order: 114 },
  { key: 46, value: 'S21',  text: 'Sommer 2021',  order: 113 },
  { key: 45, value: '21',   text: '2021',         order: 112 },
  { key: 44, value: 'W20',  text: 'Winter 20/21', order: 111 },
  { key: 43, value: 'S20',  text: 'Sommer 2020',  order: 110 },
  { key: 27, value: 'TS',   text: 'Testsaison',   order: 30 },
  { key: 18, value: 'W2',   text: 'Winter 12/13', order: 18 },
  { key: 21, value: 'HBT',  text: 'unbegrenzt',   order: 1 },
];


export const optionsHotelchain = [
    { key: 521, 	value: 521, 	text: "13 COINS HOTELS" },
    { key: 2134,	value: 2134,	text: "1834 HOTELS" },
    { key: 1661,	value: 1661,	text: "3K" },
    { key: 2129,	value: 2129,	text: "4RHotels" },
    { key: 2607,	value: 2607,	text: "525 Hotels" },
    { key: 2362,	value: 2362,	text: "7 DAYS INN" },
    { key: 1237,	value: 1237,	text: "A & H HOTELES" },
    { key: 2889,	value: 2889,	text: "A Maloof Casino Resort" },
    { key: 332,	 	value: 332,		text: "A& O HOTELS and HOSTELS Holding AG" },
    { key: 550,	 	value: 550,		text: "A-ONE HOTELS" },
    { key: 721,	 	value: 721,		text: "A-Z HOTELS" },
    { key: 719,	 	value: 719,		text: "A. FEATHER & CO. LTD TRADING AS THE FEATHERS HOTEL" },
    { key: 1610,	value: 1610,	text: "A.Q.A" },
    { key: 2986,	value: 2986,	text: "A10 Hotels" },
    { key: 1840,	value: 1840,	text: "A2 HOTELS" },
    { key: 1948,	value: 1948,	text: "AAA HOTELS & RESORTS" },
    { key: 2477,	value: 2477,	text: "AADESA HOSPITALITY MANAGEMENT COMPANY" },
    { key: 2987,	value: 2987,	text: "AAHoteles" },
    { key: 1649, 	value: 1649, 	text: "AARONS HOTELS" },
    { key: 459, 	value: 459, 	text: "ABAD GROUP OF HOTELS" },
    { key: 1432, 	value: 1432, 	text: "ABADES" },
    { key: 2913, 	value: 2913, 	text: "Abades Hoteles" },
    { key: 146, 	value: 146, 	text: "Abba" },
    { key: 3107, 	value: 3107, 	text: "Abba Hoteles" },
    { key: 744, 	value: 744, 	text: "ABBA HOTELS" },
    { key: 612, 	value: 612, 	text: "ABC GROUP OF HOTELS" },
    { key: 1034, 	value: 1034, 	text: "ABERDEEN DOUGLAS HOTEL LIMITED" },
    { key: 1173, 	value: 1173, 	text: "ABODE HOTELS" },
    { key: 86, 	 	value: 86, 		text: "Abou Nawas" },
    { key: 1505, 	value: 1505, 	text: "ABSOLUTE HOTELS SERVICES" },
    { key: 1596, 	value: 1596, 	text: "ABSOLUTE RESORTS & HOTELS" },
    { key: 2583,	value: 2583,	text: "AC by Marriott Hotels" },
    { key: 258,	 	value: 258,		text: "AC HOTELES" },
    { key: 2866,	value: 2866,	text: "AC Hotels" },
    { key: 1493, 	value: 1493, 	text: "ACADEMIA HOTELS" },
    { key: 1552, 	value: 1552, 	text: "ACCENT INN" },
    { key: 157, 	value: 157, 	text: "Accor" },
    { key: 183, 	value: 183, 	text: "ACCOR HOTELS" },
    { key: 2414, 	value: 2414, 	text: "Accor Hotels" },
    { key: 2274, 	value: 2274, 	text: "ACCORD HOTEL" },
    { key: 2132, 	value: 2132, 	text: "ACE HOTELS" },
    { key: 1393, 	value: 1393, 	text: "ACEVI" },
    { key: 2687, 	value: 2687, 	text: "Achat Hotels" },
    { key: 252, 	value: 252, 	text: "ACHAT HOTELS DEUTSCHLAND" },
    { key: 1, 		value: 1, 		text: "Acorn" }
  ];


  
export const options3LC = [
    { text: "ACE", value: "ACE", key: 3067 },
    { text: "ADB", value: "ADB", key: 3068 },
    { text: "AGA", value: "AGA", key: 3069 },
    { text: "AGP", value: "AGP", key: 3070 },
    { text: "AHO", value: "AHO", key: 3265 },
    { text: "AJR", value: "AJR", key: 3227 },
    { text: "ALC", value: "ALC", key: 3071 },
    { text: "AMS", value: "AMS", key: 3272 },
    { text: "ANU", value: "ANU", key: 3208 },
    { text: "AOI", value: "AOI", key: 3266 },
    { text: "AOK", value: "AOK", key: 3327 },
    { text: "ARN", value: "ARN", key: 3182 },
    { text: "ASE", value: "ASE", key: 3271 },
    { text: "ATH", value: "ATH", key: 3072 },
    { text: "AUA", value: "AUA", key: 3299 },
    { text: "AUH", value: "AUH", key: 3217 },
    { text: "AYT", value: "AYT", key: 3073 },
    { text: "BCN", value: "BCN", key: 3074 },
    { text: "BDS", value: "BDS", key: 3229 },
    { text: "BGI", value: "BGI", key: 3285 },
    { text: "BGY", value: "BGY", key: 3262 },
    { text: "BIO", value: "BIO", key: 3255 },
    { text: "BJV", value: "BJV", key: 3076 },
    { text: "BKK", value: "BKK", key: 3077 },
    { text: "BLQ", value: "BLQ", key: 3258 },
    { text: "BNE", value: "BNE", key: 3232 },
    { text: "BOJ", value: "BOJ", key: 3078 },
    { text: "BOS", value: "BOS", key: 3279 },
    { text: "BRI", value: "BRI", key: 3173 },
    { text: "BRN", value: "BRN", key: 3281 },
    { text: "BSL", value: "BSL", key: 3079 },
    { text: "BTS", value: "BTS", key: 3296 },
    { text: "BUD", value: "BUD", key: 3080 },
    { text: "BVC", value: "BVC", key: 3248 },
    { text: "BWK", value: "BWK", key: 3336 },
    { text: "BXM", value: "BXM", key: 3223 },
    { text: "CAG", value: "CAG", key: 3200 },
    { text: "CAI", value: "CAI", key: 3195 },
    { text: "CDG", value: "CDG", key: 3081 },
    { text: "CFU", value: "CFU", key: 3082 },
    { text: "CGN", value: "CGN", key: 3083 },
    { text: "CHQ", value: "CHQ", key: 3084 },
    { text: "CMB", value: "CMB", key: 3086 },
    { text: "CPH", value: "CPH", key: 3162 },
    { text: "CPT", value: "CPT", key: 3205 },
    { text: "CTA", value: "CTA", key: 3137 },
    { text: "CUN", value: "CUN", key: 3087 },
    { text: "CUR", value: "CUR", key: 3194 },
    { text: "DBV", value: "DBV", key: 3215 },
    { text: "DEU", value: "DEU", key: 3098 },
    { text: "DJE", value: "DJE", key: 3088 },
    { text: "DLM", value: "DLM", key: 3089 },
    { text: "DME", value: "DME", key: 3186 },
    { text: "DME", value: "DME", key: 3187 },
    { text: "DMK", value: "DMK", key: 3254 },
    { text: "DOH", value: "DOH", key: 3332 },
    { text: "DPS", value: "DPS", key: 3210 },
    { text: "DPS", value: "DPS", key: 3209 },
    { text: "DRS", value: "DRS", key: 3090 },
    { text: "DUB", value: "DUB", key: 3289 },
    { text: "DUS", value: "DUS", key: 3179 },
    { text: "DWC", value: "DWC", key: 3316 },
    { text: "DXB", value: "DXB", key: 3175 },
    { text: "ECN", value: "ECN", key: 3274 },
    { text: "EDI", value: "EDI", key: 3301 },
    { text: "EFL", value: "EFL", key: 3303 },
    { text: "EWR", value: "EWR", key: 3283 },
    { text: "EZE", value: "EZE", key: 3313 },
    { text: "FAO", value: "FAO", key: 3091 },
    { text: "FCO", value: "FCO", key: 3092 },
    { text: "FEZ", value: "FEZ", key: 3292 },
    { text: "FKB", value: "FKB", key: 3169 },
    { text: "FKB", value: "FKB", key: 3164 },
    { text: "FLL", value: "FLL", key: 3230 },
    { text: "FLR", value: "FLR", key: 3219 },
    { text: "FNC", value: "FNC", key: 3093 },
    { text: "FRA", value: "FRA", key: 3176 },
    { text: "FUE", value: "FUE", key: 3094 },
    { text: "GDN", value: "GDN", key: 3220 },
    { text: "GIG", value: "GIG", key: 3288 },
    { text: "GND", value: "GND", key: 3328 },
    { text: "GOA", value: "GOA", key: 3256 },
    { text: "GOT", value: "GOT", key: 3259 },
    { text: "GPA", value: "GPA", key: 3196 },
    { text: "GRO", value: "GRO", key: 3290 },
    { text: "GRZ", value: "GRZ", key: 3181 },
    { text: "GWT", value: "GWT", key: 3174 },
    { text: "GZP", value: "GZP", key: 3249 },
    { text: "HAJ", value: "HAJ", key: 3178 },
    { text: "HAM", value: "HAM", key: 3096 },
    { text: "HAV", value: "HAV", key: 3207 },
    { text: "HAV", value: "HAV", key: 3250 },
    { text: "HDF", value: "HDF", key: 3238 },
    { text: "HEL", value: "HEL", key: 3168 },
    { text: "HER", value: "HER", key: 3085 },
    { text: "HKG", value: "HKG", key: 3234 },
    { text: "HKT", value: "HKT", key: 3097 },
    { text: "HNL", value: "HNL", key: 3260 },
    { text: "HOG", value: "HOG", key: 3221 },
    { text: "HRG", value: "HRG", key: 3099 },
    { text: "HUH", value: "HUH", key: 3199 },
    { text: "IBZ", value: "IBZ", key: 3100 },
    { text: "INN", value: "INN", key: 3171 },
    { text: "INN", value: "INN", key: 3167 },
    { text: "IST", value: "IST", key: 3101 },
    { text: "IVL", value: "IVL", key: 3337 },
    { text: "JER", value: "JER", key: 3184 },
    { text: "JES", value: "JES", key: 3225 },
    { text: "JFK", value: "JFK", key: 3102 },
    { text: "JMK", value: "JMK", key: 3103 },
    { text: "JNB", value: "JNB", key: 3206 },
    { text: "JNX", value: "JNX", key: 3325 },
    { text: "JSH", value: "JSH", key: 3304 },
    { text: "JSI", value: "JSI", key: 3252 },
    { text: "JTR", value: "JTR", key: 3104 },
    { text: "KEF", value: "KEF", key: 3297 },
    { text: "KGS", value: "KGS", key: 3105 },
    { text: "KLU", value: "KLU", key: 3172 },
    { text: "KLX", value: "KLX", key: 3226 },
    { text: "KRK", value: "KRK", key: 3190 },
    { text: "KTT", value: "KTT", key: 3241 },
    { text: "KVA", value: "KVA", key: 3269 },
    { text: "LAS", value: "LAS", key: 3106 },
    { text: "LAX", value: "LAX", key: 3107 },
    { text: "LCA", value: "LCA", key: 3166 },
    { text: "LED", value: "LED", key: 3189 },
    { text: "LEI", value: "LEI", key: 3108 },
    { text: "LGA", value: "LGA", key: 3284 },
    { text: "LHR", value: "LHR", key: 3270 },
    { text: "LIN", value: "LIN", key: 3245 },
    { text: "LIS", value: "LIS", key: 3109 },
    { text: "LIT", value: "LIT", key: 3306 },
    { text: "LNZ", value: "LNZ", key: 3180 },
    { text: "LPA", value: "LPA", key: 3110 },
    { text: "LRM", value: "LRM", key: 3247 },
    { text: "LTN", value: "LTN", key: 3251 },
    { text: "LXR", value: "LXR", key: 3111 },
    { text: "MAD", value: "MAD", key: 3112 },
    { text: "MAH", value: "MAH", key: 3113 },
    { text: "MAN", value: "MAN", key: 3114 },
    { text: "MBA", value: "MBA", key: 3204 },
    { text: "MBJ", value: "MBJ", key: 3115 },
    { text: "MCO", value: "MCO", key: 3149 },
    { text: "MCT", value: "MCT", key: 3236 },
    { text: "MEE", value: "MEE", key: 3224 },
    { text: "MEL", value: "MEL", key: 3233 },
    { text: "MIA", value: "MIA", key: 3116 },
    { text: "MIR", value: "MIR", key: 3117 },
    { text: "MJT", value: "MJT", key: 3118 },
    { text: "MJV", value: "MJV", key: 3294 },
    { text: "MLA", value: "MLA", key: 3119 },
    { text: "MLE", value: "MLE", key: 3120 },
    { text: "MRS", value: "MRS", key: 3314 },
    { text: "MRU", value: "MRU", key: 3121 },
    { text: "MUC", value: "MUC", key: 3122 },
    { text: "MXP", value: "MXP", key: 3165 },
    { text: "NAP", value: "NAP", key: 3123 },
    { text: "NAS", value: "NAS", key: 3295 },
    { text: "NBE", value: "NBE", key: 3193 },
    { text: "NCE", value: "NCE", key: 3124 },
    { text: "NCL", value: "NCL", key: 3321 },
    { text: "NUE", value: "NUE", key: 3185 },
    { text: "OLB", value: "OLB", key: 3170 },
    { text: "OOL", value: "OOL", key: 3237 },
    { text: "OPO", value: "OPO", key: 3125 },
    { text: "ORD", value: "ORD", key: 3242 },
    { text: "ORY", value: "ORY", key: 3126 },
    { text: "OSL", value: "OSL", key: 3183 },
    { text: "PAS", value: "PAS", key: 3326 },
    { text: "PDL", value: "PDL", key: 3222 },
    { text: "PEK", value: "PEK", key: 3127 },
    { text: "PFO", value: "PFO", key: 3198 },
    { text: "PMI", value: "PMI", key: 3128 },
    { text: "PMO", value: "PMO", key: 3211 },
    { text: "POP", value: "POP", key: 3129 },
    { text: "PRG", value: "PRG", key: 3130 },
    { text: "PRI", value: "PRI", key: 3276 },
    { text: "PRI", value: "PRI", key: 3298 },
    { text: "PSA", value: "PSA", key: 3257 },
    { text: "PTY", value: "PTY", key: 3253 },
    { text: "PUJ", value: "PUJ", key: 3131 },
    { text: "PUY", value: "PUY", key: 3287 },
    { text: "PVG", value: "PVG", key: 3132 },
    { text: "PVK", value: "PVK", key: 3324 },
    { text: "PXO", value: "PXO", key: 3244 },
    { text: "RAB", value: "RAB", key: 3293 },
    { text: "RAK", value: "RAK", key: 3133 },
    { text: "REG", value: "REG", key: 3267 },
    { text: "REU", value: "REU", key: 3291 },
    { text: "RHO", value: "RHO", key: 3134 },
    { text: "RIX", value: "RIX", key: 3300 },
    { text: "RJK", value: "RJK", key: 3309 },
    { text: "RKT", value: "RKT", key: 3312 },
    { text: "RMF", value: "RMF", key: 3135 },
    { text: "ROM", value: "ROM", key: 3331 },
    { text: "RSW", value: "RSW", key: 3136 },
    { text: "RVN", value: "RVN", key: 3335 },
    { text: "SDQ", value: "SDQ", key: 3246 },
    { text: "SEZ", value: "SEZ", key: 3201 },
    { text: "SFO", value: "SFO", key: 3273 },
    { text: "SGN", value: "SGN", key: 3240 },
    { text: "SHJ", value: "SHJ", key: 3315 },
    { text: "SIA", value: "SIA", key: 3235 },
    { text: "SID", value: "SID", key: 3214 },
    { text: "SJC", value: "SJC", key: 3286 },
    { text: "SJD", value: "SJD", key: 3334 },
    { text: "SJJ", value: "SJJ", key: 3320 },
    { text: "SJO", value: "SJO", key: 3243 },
    { text: "SJU", value: "SJU", key: 3305 },
    { text: "SKG", value: "SKG", key: 3138 },
    { text: "SLL", value: "SLL", key: 3338 },
    { text: "SMI", value: "SMI", key: 3139 },
    { text: "SNU", value: "SNU", key: 3282 },
    { text: "SOF", value: "SOF", key: 3239 },
    { text: "SPC", value: "SPC", key: 3140 },
    { text: "SPU", value: "SPU", key: 3141 },
    { text: "SSH", value: "SSH", key: 3142 },
    { text: "STN", value: "STN", key: 3095 },
    { text: "STR", value: "STR", key: 3144 },
    { text: "SUF", value: "SUF", key: 3202 },
    { text: "SVQ", value: "SVQ", key: 3203 },
    { text: "SXF", value: "SXF", key: 3145 },
    { text: "SYD", value: "SYD", key: 3231 },
    { text: "SZG", value: "SZG", key: 3146 },
    { text: "TAB", value: "TAB", key: 3212 },
    { text: "TBS", value: "TBS", key: 3330 },
    { text: "TER", value: "TER", key: 3280 },
    { text: "TFN", value: "TFN", key: 3147 },
    { text: "TFS", value: "TFS", key: 3148 },
    { text: "TGD", value: "TGD", key: 3308 },
    { text: "TIA", value: "TIA", key: 3323 },
    { text: "TIV", value: "TIV", key: 3310 },
    { text: "TLL", value: "TLL", key: 3302 },
    { text: "TLV", value: "TLV", key: 3191 },
    { text: "TOS", value: "TOS", key: 3329 },
    { text: "TPA", value: "TPA", key: 3261 },
    { text: "TRN", value: "TRN", key: 3264 },
    { text: "TRS", value: "TRS", key: 3268 },
    { text: "TUN", value: "TUN", key: 3192 },
    { text: "TXL", value: "TXL", key: 3075 },
    { text: "USM", value: "USM", key: 3150 },
    { text: "UVF", value: "UVF", key: 3213 },
    { text: "VAR", value: "VAR", key: 3151 },
    { text: "VCE", value: "VCE", key: 3152 },
    { text: "VIE", value: "VIE", key: 3153 },
    { text: "VLC", value: "VLC", key: 3154 },
    { text: "VNO", value: "VNO", key: 3307 },
    { text: "VOL", value: "VOL", key: 3155 },
    { text: "VRA", value: "VRA", key: 3156 },
    { text: "VRN", value: "VRN", key: 3177 },
    { text: "WAW", value: "WAW", key: 3228 },
    { text: "WDH", value: "WDH", key: 3311 },
    { text: "XRY", value: "XRY", key: 3157 },
    { text: "YHZ", value: "YHZ", key: 3319 },
    { text: "YLW", value: "YLW", key: 3263 },
    { text: "YUL", value: "YUL", key: 3318 },
    { text: "YVR", value: "YVR", key: 3161 },
    { text: "YVZ", value: "YVZ", key: 3158 },
    { text: "YYC", value: "YYC", key: 3317 },
    { text: "YYZ", value: "YYZ", key: 3159 },
    { text: "ZAD", value: "ZAD", key: 3275 },
    { text: "ZAG", value: "ZAG", key: 3278 },
    { text: "ZNZ", value: "ZNZ", key: 3322 },
    { text: "ZRH", value: "ZRH", key: 3143 },
    { text: "ZTH", value: "ZTH", key: 3160 }
  ];


export const optionsAgency = [
    { key: 2775, text: "UTS Djerba", value: "DJE80" },
    { key: 3209, text: "Doufexis ", value: "KLX10" },
    { key: 3740, text: "UTS Tunis", value: "NBE80" },
    { key: 3555, text: "FUE Viajes Canarias Europa", value: "FUE70EN" },
    { key: 2007, text: "CRETAN HOLIDAYS", value: "CHQ70" },
    { key: 3171, text: "TRAVEL PARTNER REISEN", value: "MUC300" },
    { key: 3284, text: "Eurotours", value: "AT001" },
    { key: 3436, text: "World2Meet Marrakech", value: "wrak70IT" },
    { key: 3449, text: "World2Meet Varna", value: "WVAR70" },
    { key: 2789, text: "MTS Globe ", value: "LCA70" },
    { key: 2764, text: "Travel Partner Reisen (Budapest)", value: "BUD77" },
    { key: 3281, text: "MTS Cabo Verde", value: "SID70" },
    { key: 3541, text: "Viajes Sidetours Malaga", value: "AGP70FR" },
    { key: 3590, text: "Doufexis ", value: "KLX10EN" },
    { key: 3249, text: "NH Hotels", value: "NH100" },
    { key: 3213, text: "Cacao Travel Group Panama", value: "PTY100" },
    { key: 3261, text: "booked and billed by TeamAmerica", value: "JFK30" },
    { key: 3402, text: "World2Meet Coast Murcia", value: "WMJV70ES" },
    { key: 2759, text: "HAMAN", value: "OSL01" },
    { key: 3182, text: "Hotelbeds_Barbados", value: "HTBBAR" },
    { key: 3248, text: "Hotelbeds_Hawaii", value: "HTBHNL" },
    { key: 3266, text: "Travel Partner Reisen (Graz)", value: "GRZ70" },
    { key: 3431, text: "World2Meet Marrakech", value: "WRAK70EN" },
    { key: 3463, text: "The Chedi Hotel", value: "TGD70EN" },
    { key: 3741, text: "Diethelm Travel", value: "MLE20" },
    { key: 3542, text: "Viajes Sidetours Malaga", value: "AGP70ES" },
    { key: 3500, text: "Focus Asia Thailand", value: "BKK100FR" },
    { key: 3422, text: "Acampora Travel", value: "NAP714" },
    { key: 3435, text: "World2Meet Marrakech", value: "WRAK70ES" },
    { key: 3556, text: "FUE Viajes Canarias Europa", value: "FUE70ES" },
    { key: 2847, text: "Gulliver Travel", value: "DBV70" },
    { key: 2745, text: "Acampora", value: "FCO72" },
    { key: 3250, text: "Hotels & More (London)", value: "LHR72" },
    { key: 3200, text: "Welcome Incoming Service", value: "VRA80" },
    { key: 2844, text: "Hotelbeds Thailand", value: "USM80" },
    { key: 3742, text: "CRETAN HOLIDAYS", value: "AOK10" },
    { key: 3174, text: "CRETAN HOLIDAYS", value: "KGS100" },
    { key: 3591, text: "Doufexis ", value: "KLX10ES" },
    { key: 3146, text: "PAID BY Tourico Holiday, INC.", value: "TXL81" },
    { key: 3509, text: "Sidetours Incoming Services", value: "PMI72FR" },
    { key: 3251, text: "CRETAN HOLIDAYS", value: "RHO100" },
    { key: 2822, text: "Hotelbeds_Mauritius", value: "HTBMRU" },
    { key: 3268, text: "OTS Full Service Group", value: "TER80" },
    { key: 3464, text: "The Chedi Hotel", value: "TGD70" },
    { key: 3286, text: "hotelbeds St. Lucia", value: "UVF70" },
    { key: 1961, text: "ATASE TOURISM", value: "BJV70" },
    { key: 3558, text: "ACE Canarias Europa", value: "ACE70FR" },
    { key: 3170, text: "Business Serenity Ltd.", value: "CUR30" },
    { key: 3716, text: "Mirihi Island Resort", value: "MLE38" },
    { key: 3437, text: "World2Meet Marrakech", value: "WRAK70" },
    { key: 3355, text: "World2Meet Malta", value: "WMLA70ES" },
    { key: 3468, text: "Viajes Sidetours Malaga", value: "AGP70EN" },
    { key: 3438, text: "World2Meet Marrakech", value: "WAGA70EN" },
    { key: 3351, text: "World2Meet Lanzarote", value: "WACE70ES" },
    { key: 3287, text: "hotelbeds CPT", value: "CPT70" },
    { key: 2825, text: "Hotelbeds_Bali", value: "HTBRI" },
    { key: 2851, text: "keine", value: "HLX01" },
    { key: 2829, text: "Hotelbeds_Namibia", value: "HTBNAM" },
    { key: 2831, text: "Hotelbeds_Antigua", value: "HTBANT" },
    { key: 3292, text: "AMSTAR TRAVEL SERVICES, S. DE R.L. DE C.V.", value: "PUJ10" },
    { key: 3302, text: "World2Meet  Gran Canaria", value: "WLPA70EN" },
    { key: 3272, text: "Westin Times Square", value: "JFK100" },
    { key: 3318, text: "World2Meet Lissabon", value: "WLIS70" },
    { key: 3265, text: "Adriatic Travel & Trade", value: "ZAG70" },
    { key: 3259, text: "Hotelbeds_MIA", value: "HTBMIA" },
    { key: 3294, text: "World2Meet Costa Blanca", value: "WALC70EN" },
    { key: 3378, text: "De Palm Tours Aruba/Inter-Connect-Marketing GmbH", value: "AUA80" },
    { key: 3256, text: "Angela Shanley Associates ", value: "LHR80" },
    { key: 3290, text: "BLANDY TOURISM SERVICES", value: "PXO80" },
    { key: 3252, text: "Hotelbeds Seychellen", value: "HTBSEZ" },
    { key: 3257, text: "Service Team", value: "YVRSKI" },
    { key: 3559, text: "ACE Canarias Europa", value: "ACE70ES" },
    { key: 3303, text: "World2Meet Fuerteventura", value: "WFUE70EN" },
    { key: 3300, text: "World2Meet Teneriffa", value: "WTFS70EN" },
    { key: 3258, text: "Service Team", value: "ASESKI" },
    { key: 3278, text: "Interconnect Marketing", value: "BGI10" },
    { key: 3262, text: "TRAVEL PARTNER REISEN (Hamburg)", value: "HAM170" },
    { key: 3201, text: "Welcome Incoming Service", value: "POP60" },
    { key: 3275, text: "APTC All Pacific Travel Concept", value: "SYD70" },
    { key: 3276, text: "TRAVEL PARTNER REISEN (TXL)", value: "TXL70" },
    { key: 3280, text: "Angela Shanley Associates ", value: "ORY40" },
    { key: 3467, text: "Amiel Tours Ltd", value: "TLV100" },
    { key: 3439, text: "World2Meet Marrakech", value: "WAGA70" },
    { key: 3469, text: "Viajes Sidetours (telef.RL)", value: "AGP71EN" },
    { key: 3729, text: "OTS Jamaica", value: "MBJ01" },
    { key: 3305, text: "World2Meet Lanzarote", value: "WACE70EN" },
    { key: 3274, text: "Masons Travel ", value: "SEZ70" },
    { key: 3310, text: "World2Meet Menorca", value: "WMAH70" },
    { key: 3399, text: "World2Meet Coast Murcia", value: "WMJV70" },
    { key: 3592, text: "Doufexis ", value: "KLX10FR" },
    { key: 3442, text: "World2Meet Marrakech", value: "WRBA70IT" },
    { key: 3283, text: "MTS Cabo Verde", value: "BVC70" },
    { key: 3440, text: "World2Meet Marrakech", value: "WAGA70ES" },
    { key: 3401, text: "World2Meet Coast Murcia", value: "WMJV70IT" },
    { key: 3338, text: "World2Meet  Gran Canaria", value: "WLPA70ES" },
    { key: 3466, text: "OTS / MTS Globe", value: "MLE90" },
    { key: 3339, text: "World2Meet  Gran Canaria", value: "WLPA70IT" },
    { key: 3291, text: "AMSTAR TRAVEL SERVICES, S. DE R.L. DE C.V.", value: "CUN10" },
    { key: 3441, text: "World2Meet Marrakech", value: "WAGA70IT" },
    { key: 3371, text: "World2Meet Barcelona", value: "WBCN70ES" },
    { key: 3372, text: "World2Meet Barcelona", value: "WBCN70IT" },
    { key: 2846, text: "Holiday Moments", value: "DXB80" },
    { key: 3385, text: "CRETAN HOLIDAYS", value: "KGS100ES" },
    { key: 3719, text: "LUX North Male Atoll", value: "MLE37" },
    { key: 3745, text: "MTS globe", value: "RMF50" },
    { key: 2682, text: "TRAVEL PARTNER REISEN (Wien)", value: "VIE70" },
    { key: 2784, text: "ACE Canarias Europa", value: "ACE70" },
    { key: 3443, text: "World2Meet Marrakech", value: "WRBA70ES" },
    { key: 3346, text: "World2Meet Fuerteventura", value: "WFUE70IT" },
    { key: 3419, text: "MTS Globe ", value: "LCA70ES" },
    { key: 3717, text: "RIU Atoll", value: "MLE35" },
    { key: 3444, text: "World2Meet Marrakech", value: "WRBA70" },
    { key: 3392, text: "World2Meet Teneriffa", value: "WTFN70" },
    { key: 3447, text: "World2Meet Dalaman", value: "WDLM70" },
    { key: 3744, text: "MTS globe", value: "SSH50" },
    { key: 3560, text: "LPA Viajes Canarias Europa", value: "LPA70FR" },
    { key: 3393, text: "World2Meet Teneriffa", value: "WTFN70EN" },
    { key: 3445, text: "World2Meet Marrakech", value: "WRBA70EN" },
    { key: 3350, text: "World2Meet Teneriffa", value: "WTFS70IT" },
    { key: 3396, text: "Inova Hospitality", value: "JSI10" },
    { key: 3297, text: "World2Meet Costa Brava", value: "WGRO70" },
    { key: 3301, text: "World2Meet  Gran Canaria", value: "WLPA70" },
    { key: 3273, text: "Desert Gate Tourism", value: "MCT70" },
    { key: 3313, text: "World2Meet Malaga", value: "WAGP70EN" },
    { key: 3295, text: "World2Meet Costa Almeria", value: "WLEI70" },
    { key: 3446, text: "World2Meet Dalaman", value: "WDLM70EN" },
    { key: 3296, text: "World2Meet Costa Almeria", value: "WLEI70EN" },
    { key: 2858, text: "New World Travel Inc.", value: "MIA72" },
    { key: 3394, text: "World2Meet Teneriffa", value: "WTFN70ES" },
    { key: 3299, text: "World2Meet Teneriffa", value: "WTFS70" },
    { key: 3322, text: "World2Meet Algarve", value: "WFAO70" },
    { key: 3377, text: "AMSTAR TRAVEL SERVICES, S. DE R.L. DE C.V.,Jamaica", value: "MBJ10" },
    { key: 3543, text: "Viajes Sidetours (telef.RL)", value: "AGP71ES" },
    { key: 3448, text: "World2Meet Varna", value: "WVAR70EN" },
    { key: 2832, text: "Hotelbeds_MEX", value: "HTBMEX" },
    { key: 3271, text: "Inner Maldives Holidays", value: "MLE70" },
    { key: 3139, text: "Viajes Sidetours (telef.RL)", value: "BCN80" },
    { key: 3747, text: "Welcome Incoming Service", value: "HAV80" },
    { key: 3395, text: "World2Meet Teneriffa", value: "WTFN70IT" },
    { key: 3327, text: "Travel Partner Reisen (Bratislava)", value: "BTS77" },
    { key: 3314, text: "World2Meet Malaga", value: "WAGP70" },
    { key: 3323, text: "World2Meet Azores", value: "WPDL70EN" },
    { key: 2810, text: "HOTELBEDS S.L.U. _ France", value: "HTBFR" },
    { key: 3269, text: "Viajes Sidetours ", value: "BCN90" },
    { key: 2204, text: "Sidetours Incoming Services", value: "IBZ70" },
    { key: 3379, text: "Amazing Africa", value: "CPT50" },
    { key: 3324, text: "World2Meet Azoren", value: "WPDL70" },
    { key: 3749, text: "World2Meet", value: "HAV10" },
    { key: 3335, text: "World2Meet Lissabon", value: "WLIS70IT" },
    { key: 3495, text: "Desert Gate Tourism", value: "MCT70EN" },
    { key: 3306, text: "World2Meet Lanzarote", value: "WACE70" },
    { key: 3328, text: "World2Meet Jerez", value: "WXRY70" },
    { key: 3450, text: "World2Meet Varna", value: "WVAR70ES" },
    { key: 3451, text: "World2Meet Varna", value: "WVAR70IT" },
    { key: 3329, text: "World2Meet Jerez", value: "WXRY70EN" },
    { key: 3606, text: "Viajes Sidetours Malaga", value: "LEI70FR" },
    { key: 2859, text: "New World Travel Inc.", value: "RSW72" },
    { key: 3473, text: "MTS Globe AYT", value: "BJV80" },
    { key: 3325, text: "World2Meet Malta", value: "WMLA70EN" },
    { key: 3470, text: "Focus Asia Thailand", value: "BKK100" },
    { key: 3427, text: "Frankenland Reisen e.K.", value: "PRG70" },
    { key: 3498, text: "Desert Gate Tourism", value: "MCT70ES" },
    { key: 3748, text: "World2Meet", value: "VRA10" },
    { key: 3743, text: "MTS Globe", value: "PMI80" },
    { key: 3398, text: "Angela Shanley Associates ", value: "EDI80" },
    { key: 3452, text: "World2Meet Varna", value: "WBOJ70EN" },
    { key: 3499, text: "Desert Gate Tourism", value: "MCT70FR" },
    { key: 3562, text: "LPA Viajes Canarias Europa", value: "LPA70ES" },
    { key: 2780, text: "Taber Tours/Inter-Connect-Marketing GmbH", value: "CUR80" },
    { key: 3750, text: "World2Meet", value: "HOG10" },
    { key: 3309, text: "World2Meet Menorca", value: "WMAH70EN" },
    { key: 3400, text: "World2Meet Coast Murcia", value: "WMJV70EN" },
    { key: 3321, text: "World2Meet Algarve", value: "WFAO70EN" },
    { key: 3718, text: "RIU Palace Maldivas", value: "MLE36" },
    { key: 3334, text: "World2Meet Lissabon", value: "WLIS70ES" },
    { key: 3453, text: "World2Meet Varna", value: "WBOJ70" },
    { key: 3579, text: "SPC VIAJES CANARIAS EUROPA", value: "SPC70FR" },
    { key: 3340, text: "World2Meet Costa Almeria", value: "WLEI70ES" },
    { key: 3311, text: "World2Meet Ibiza", value: "WIBZ70EN" },
    { key: 3341, text: "World2Meet Costa Almeria", value: "WLEI70IT" },
    { key: 3474, text: "MTS Globe AYT", value: "DLM80" },
    { key: 3720, text: "LUX South Ari Atoll", value: "MLE15" },
    { key: 3454, text: "World2Meet Varna", value: "WBOJ70ES" },
    { key: 3342, text: "World2Meet Costa Blanca", value: "WALC70ES" },
    { key: 3455, text: "World2Meet Varna", value: "WBOJ70IT" },
    { key: 3312, text: "World2Meet Ibiza", value: "WIBZ70" },
    { key: 3352, text: "World2Meet Lanzarote", value: "WACE70IT" },
    { key: 3694, text: "Ovest Viaggi", value: "ITA70" },
    { key: 3721, text: "Reethi Beach Resort", value: "MLE14" },
    { key: 3336, text: "World2Meet Malaga", value: "WAGP70ES" },
    { key: 2752, text: "Hotels & More (London)", value: "STN72" },
    { key: 3418, text: "MTS Globe ", value: "LCA70IT" },
    { key: 2762, text: "Robert Arrigo & Sons Ltd. ", value: "MLA70" },
    { key: 3373, text: "Haman Scandinavia AS", value: "ARN60" },
    { key: 3288, text: "Viajes Sidetours Malaga", value: "LEI70" },
    { key: 3426, text: "MTS Globe AYT", value: "AYT80" },
    { key: 3337, text: "World2Meet Malaga", value: "WAGP70IT" },
    { key: 3289, text: "Viajes Sidetours (telef.RL)", value: "LEI71" },
    { key: 2849, text: "Sidetours Incoming Services", value: "PMI72" },
    { key: 3505, text: "Cassata Travel Srl", value: "CTA73EN" },
    { key: 3158, text: "Acanthus Tours", value: "DUS90" },
    { key: 3515, text: "Cassata Travel Srl", value: "CTA73ES" },
    { key: 3326, text: "World2Meet Malta", value: "WMLA70" },
    { key: 3344, text: "World2Meet Costa Blanca", value: "WALC70IT" },
    { key: 3695, text: "West Indian International Tours", value: "BGI11" },
    { key: 3354, text: "World2Meet Mallorca", value: "WPMI70IT" },
    { key: 3293, text: "World2Meet Costa Blanca", value: "WALC70" },
    { key: 3567, text: "Robert Arrigo & Sons Ltd. ", value: "MLA70ES" },
    { key: 3308, text: "World2Meet Mallorca", value: "WPMI70" },
    { key: 2300, text: "LPA Viajes Canarias Europa", value: "LPA70" },
    { key: 3137, text: "SMI Regina Travel", value: "SMI72" },
    { key: 3317, text: "World2Meet Lissabon", value: "WLIS70EN" },
    { key: 3347, text: "World2Meet Azores", value: "WPDL70ES" },
    { key: 3459, text: "Cretan Holidays Promo", value: "SKG100" },
    { key: 3307, text: "World2Meet Mallorca", value: "WPMI70EN" },
    { key: 3357, text: "World2Meet Jerez", value: "WXRY70ES" },
    { key: 3356, text: "World2Meet Malta", value: "WMLA70IT" },
    { key: 3487, text: "CRETAN HOLIDAYS", value: "CHQ70ES" },
    { key: 3136, text: "SMI Regina Travel", value: "SMI70" },
    { key: 3353, text: "World2Meet Mallorca", value: "WPMI70ES" },
    { key: 3476, text: "MTS Globe", value: "LCA71" },
    { key: 3348, text: "World2Meet Azores", value: "WPDL70IT" },
    { key: 3304, text: "World2Meet Fuerteventura", value: "WFUE70" },
    { key: 3425, text: "MTS Zakynthos Kefalonia", value: "EFL70EN" },
    { key: 3722, text: "Reethi Faru Resort", value: "MLE33" },
    { key: 3349, text: "World2Meet Teneriffa", value: "WTFS70ES" },
    { key: 3194, text: "Tourico Holidays", value: "JFK91" },
    { key: 3359, text: "World2Meet Jerez", value: "WXRY70IT" },
    { key: 2757, text: "Acampora Travel", value: "NAP71" },
    { key: 3563, text: "SMI Regina Travel", value: "SMI70EN" },
    { key: 2630, text: "TRAVEL PARTNER REISEN", value: "SZG70" },
    { key: 2813, text: "HOTELBEDS S.L.U. _ NO", value: "HTBNO" },
    { key: 3566, text: "Robert Arrigo & Sons Ltd. ", value: "MLA70EN" },
    { key: 3360, text: "World2Meet Algarve", value: "WFAO70ES" },
    { key: 3298, text: "World2Meet Costa Brava", value: "WGRO70EN" },
    { key: 3601, text: "MTS Santorini", value: "JTR90FR" },
    { key: 3361, text: "World2Meet Algarve", value: "WFAO70IT" },
    { key: 3483, text: "Focus Asia Thailand", value: "BKK100ES" },
    { key: 3315, text: "World2Meet Reus/Costa Dorada", value: "WREU70EN" },
    { key: 3210, text: "MTS Incoming ", value: "MJT10" },
    { key: 2793, text: "LPA Viajes Canarias Europa (tel.)", value: "LPA72" },
    { key: 3260, text: "MTS Mykonos", value: "JMK90" },
    { key: 2207, text: "Destination Services Turkey", value: "IST70" },
    { key: 2610, text: "HOTELBEDS UK L.T.D.", value: "STN70" },
    { key: 3159, text: "Phileas France", value: "ORY300" },
    { key: 3316, text: "World2Meet Reus/Costa Dorada", value: "WREU70" },
    { key: 3362, text: "World2Meet Menorca", value: "WMAH70ES" },
    { key: 2774, text: "UTS Sousse", value: "MIR80" },
    { key: 2684, text: "HOTELBEDS S.L.U. _ VLC", value: "VLC70" },
    { key: 3696, text: "My Seychelles", value: "SEZ100" },
    { key: 3363, text: "World2Meet Menorca", value: "WMAH70IT" },
    { key: 3320, text: "World2Meet Barcelona", value: "WBCN70" },
    { key: 3482, text: "Focus Asia Thailand", value: "BKK100EN" },
    { key: 3477, text: "CRETAN HOLIDAYS", value: "KGS100FR" },
    { key: 3319, text: "World2Meet Barcelona", value: "WBCN70EN" },
    { key: 3565, text: "SMI Regina Travel", value: "SMI70FR" },
    { key: 3162, text: "MTS Fuerteventura", value: "FUE80" },
    { key: 2779, text: "MTS Egypt CAI", value: "CAI80" },
    { key: 3364, text: "World2Meet Costa Brava", value: "WGRO70ES" },
    { key: 3161, text: "Holiday Shop Bulgarien", value: "SOF80" },
    { key: 3502, text: "Sidetours Incoming Services", value: "PMI70ES" },
    { key: 3564, text: "SMI Regina Travel", value: "SMI70ES" },
    { key: 3365, text: "World2Meet Costa Brava", value: "WGRO70IT" },
    { key: 3369, text: "World2Meet Ibiza", value: "WIBZ70ES" },
    { key: 3595, text: "MTS Mykonos", value: "JMK90FR" },
    { key: 3147, text: "Regal Holiday (tel.Reiseleitung)", value: "ADB70" },
    { key: 3366, text: "World2Meet Reus/Costa Dorada", value: "WREU70ES" },
    { key: 3345, text: "World2Meet Fuerteventura", value: "WFUE70ES" },
    { key: 2800, text: "Villa Holidays", value: "MLE74" },
    { key: 3456, text: "PUZZLE TOURISM (tel. Reiseleitung)", value: "DLM70EN" },
    { key: 3698, text: "Terra Nova Tours", value: "CPT101" },
    { key: 3580, text: "SPC VIAJES CANARIAS EUROPA", value: "SPC70ES" },
    { key: 2836, text: "Hotelbeds_Tobago", value: "HTBTOB" },
    { key: 3277, text: "SUMMERTIMES", value: "MRU70" },
    { key: 3460, text: "Regal Holiday (tel.Reiseleitung)", value: "ADB71" },
    { key: 3207, text: "Welcome Incoming Service", value: "CUN81" },
    { key: 3367, text: "World2Meet Reus/Costa Dorada", value: "WREU70IT" },
    { key: 3264, text: "debase online", value: "ECN70" },
    { key: 3461, text: "ATASE TOURISM", value: "BJV71" },
    { key: 3697, text: "Terra Nova Tours", value: "CPT100" },
    { key: 3409, text: "Travco Travel Company", value: "RMF60" },
    { key: 3380, text: "CRETAN HOLIDAYS", value: "HER70EN" },
    { key: 3164, text: "MTS globe", value: "HRG50" },
    { key: 3462, text: "PUZZLE TOURISM (tel. Reiseleitung)", value: "DLM71" },
    { key: 3370, text: "World2Meet Ibiza", value: "WIBZ70IT" },
    { key: 2855, text: "Viajes Sidetours PT telefon. Reiseleitung", value: "LIS71" },
    { key: 2159, text: "CRETAN HOLIDAYS", value: "HER70" },
    { key: 3215, text: "Liberty International Scandinavia", value: "CPH80" },
    { key: 3181, text: "Hotelbeds_St. Martin", value: "HTBSTM" },
    { key: 3168, text: "Tourico Holidays", value: "JFK90" },
    { key: 2353, text: "HOTELBEDS FLORIDA", value: "MIA71" },
    { key: 3488, text: "CRETAN HOLIDAYS", value: "CHQ70FR" },
    { key: 2781, text: "Taber Tours/Inter-Connect-Marketing GmbH", value: "CUR70" },
    { key: 2818, text: "TUI HOLIDAY TRAVEL telefonsich", value: "TLV72" },
    { key: 2790, text: "Stubai Touristik", value: "INN80" },
    { key: 2211, text: "booked and billed by New World Travel, Inc.", value: "JFK70" },
    { key: 3160, text: "Inter-Connect Marketing", value: "JFK80" },
    { key: 2786, text: "ltur Test", value: "lt5555" },
    { key: 3140, text: "TUI Austria Holding GmbH", value: "LNZ80" },
    { key: 2815, text: "HOTELBEDS S.L.U. _ DE", value: "HTBDE" },
    { key: 2760, text: "Haman Scandinavia AS", value: "ARN50" },
    { key: 3166, text: "Asian Adventures", value: "CMB80" },
    { key: 3593, text: "MTS Mykonos", value: "JMK90EN" },
    { key: 3192, text: "Cassata Travel Srl", value: "CTA73" },
    { key: 3145, text: "Ateam - Testagentur", value: "ATEST" },
    { key: 3403, text: "CRETAN HOLIDAYS", value: "HER70IT" },
    { key: 3131, text: "Hotelbeds_Portugal", value: "HTBPT" },
    { key: 3594, text: "MTS Mykonos", value: "JMK90ES" },
    { key: 3178, text: "Hotelbeds_Portugal", value: "HTBPOR" },
    { key: 3184, text: "Hotelbeds_Indonesien", value: "HTBBAL" },
    { key: 3180, text: "Hotelbeds_Kanada", value: "HTBCAN" },
    { key: 2767, text: "HOTELBEDS S.L.U. _ DME", value: "DME70" },
    { key: 3151, text: "TravelPartnerReisen Innsbruck", value: "INN72" },
    { key: 2824, text: "Hotelbeds_ZA", value: "HTBZA" },
    { key: 2756, text: "Steigenberger Herrenhof", value: "VIE73" },
    { key: 3188, text: "Dunas Travel", value: "PXO70" },
    { key: 3381, text: "CRETAN HOLIDAYS", value: "HER70ES" },
    { key: 2074, text: "PUZZLE TOURISM (tel. Reiseleitung)", value: "DLM70" },
    { key: 2087, text: "DESERT ADVENTURES TOURISM", value: "DXB70" },
    { key: 3699, text: "FUE Viajes Canarias Europa", value: "FUE72FR" },
    { key: 2835, text: "Tanya Guerrero ", value: "HTBCR" },
    { key: 3152, text: "Destination Jokkmokk", value: "AJR70" },
    { key: 2834, text: "Hotelbeds_St.Lucia", value: "HTBSTL" },
    { key: 3501, text: "Sidetours Incoming Services", value: "PMI70EN" },
    { key: 2848, text: "Gulliver Travel", value: "SPU70" },
    { key: 1942, text: "Destination Services Turkey Turizm ve Seyahat A.S.", value: "AYT70" },
    { key: 3153, text: "HOTELBEDS S.L.U. _ Krakau", value: "WAW70" },
    { key: 3331, text: "MTS Globe", value: "RMF70" },
    { key: 3382, text: "Cretan Holidays Destinations Management", value: "CFU80EN" },
    { key: 2856, text: "Viajes Sidetours Portugal telef.Reiseleitung", value: "FAO80" },
    { key: 3506, text: "Sidetours Incoming Services", value: "PMI72EN" },
    { key: 2595, text: "SPC VIAJES CANARIAS EUROPA", value: "SPC70" },
    { key: 3143, text: "HOTELBEDS-KLX", value: "HTBKLX" },
    { key: 2748, text: "Viajes Sidetours Portugal", value: "FAO71" },
    { key: 3700, text: "FUE Viajes Canarias Europa", value: "FUE72ES" },
    { key: 2744, text: "Viajes Sidetours Malaga", value: "AGP70" },
    { key: 3149, text: "HOTELBEDS S.L.U. _ ARN", value: "ARN70" },
    { key: 2819, text: "Hotelbeds Florida (telefonische RL)", value: "RSW71" },
    { key: 2838, text: "hotelbeds NY", value: "JFK71" },
    { key: 3410, text: "Travco Travel Company", value: "SSH60" },
    { key: 3150, text: "HOTELBEDS S.L.U. _ HEL", value: "HEL71" },
    { key: 2805, text: "Acanthus Tours", value: "TXL77" },
    { key: 3383, text: "Cretan Holidays Destinations Management", value: "CFU80ES" },
    { key: 2761, text: "Hotels & More (Jersey)", value: "JER01" },
    { key: 3589, text: "CRETAN HOLIDAYS", value: "RHO100ES" },
    { key: 3132, text: "HOTELBEDS S.L.U._Niederländische Antillen", value: "HTBABC" },
    { key: 3588, text: "CRETAN HOLIDAYS", value: "RHO100FR" },
    { key: 2808, text: "HOTELBEDS S.L.U. _ NL", value: "HTBNL" },
    { key: 3390, text: "Acampora Travel", value: "NAP71IT" },
    { key: 2766, text: "Travel Partner Reisen (Salzburg)", value: "SZG72" },
    { key: 2811, text: "HOTELBEDS S.L.U. _ CH", value: "HTBCH" },
    { key: 2770, text: "Holiday Shop Bulgarien", value: "BOJ80" },
    { key: 2750, text: "Lets Go Maldives", value: "MLE60" },
    { key: 2763, text: "TUI Austria Holding GmbH", value: "SZG80" },
    { key: 2803, text: "TUI HOLIDAY TRAVEL", value: "TLV71" },
    { key: 3384, text: "CRETAN HOLIDAYS", value: "KGS100EN" },
    { key: 3492, text: "SUMMERTIMES", value: "MRU70EN" },
    { key: 2792, text: "FUE Viajes Canarias Europa", value: "FUE72" },
    { key: 3525, text: "Cassata Travel Srl", value: "CTA73FR" },
    { key: 3177, text: "Hotelbeds_Oman", value: "HTBOMA" },
    { key: 2754, text: "Liberty France (Nice)", value: "NCE72" },
    { key: 2827, text: "Hotelbeds_SY", value: "HTBSY" },
    { key: 2812, text: "HOTELBEDS S.L.U. _ FI", value: "HTBFI" },
    { key: 2749, text: "Liberty France (Paris)", value: "ORY72" },
    { key: 3128, text: "HOTELBEDS S.L.U. _ Danzig", value: "GDN70" },
    { key: 3465, text: "MTS Athens", value: "ATH90" },
    { key: 3133, text: "New World Travel Inc.", value: "LAX72" },
    { key: 2312, text: "HOTELBEDS S.L.U. _ MAD", value: "MAD70" },
    { key: 2809, text: "HOTELBEDS S.L.U. _ Italy", value: "HTBIT" },
    { key: 2769, text: "Holiday Shop Bulgarien", value: "VAR80" },
    { key: 3493, text: "SUMMERTIMES", value: "MRU70ES" },
    { key: 2802, text: "HOTELBEDS S.L.U. _ Krakau", value: "KRK70" },
    { key: 2772, text: "HOTELBEDS S.L.U. _ LED", value: "LED70" },
    { key: 3186, text: "OTS Full Service Group", value: "PDL80" },
    { key: 2776, text: "UTS Tunis", value: "TUN80" },
    { key: 2814, text: "HOTELBEDS S.L.U. _ DK", value: "HTBDK" },
    { key: 2821, text: "HOTELBEDS S.L.U. _ SE", value: "HTBSE" },
    { key: 3167, text: "Asian Adventures (telefonisch)", value: "CMB82" },
    { key: 3429, text: "CRETAN HOLIDAYS", value: "CHQ70EN" },
    { key: 3148, text: "Dom Rep Tours", value: "POP80" },
    { key: 3179, text: "Hotelbeds_Seychellen", value: "HTBSEY" },
    { key: 3169, text: "Business Serenity Ltd.", value: "CUR20" },
    { key: 3138, text: "Destination Services Turkey Turizm ve Seyahat A.S.   (telefonische Reiseleitung)", value: "AYT71" },
    { key: 3154, text: "MTS Globe", value: "RHO70" },
    { key: 3163, text: "HOTELBEDS_SGN", value: "SGN70" },
    { key: 3494, text: "SUMMERTIMES", value: "MRU70FR" },
    { key: 3507, text: "Sidetours Incoming Services", value: "PMI72ES" },
    { key: 3191, text: "Holiday Moments", value: "AUH80" },
    { key: 3172, text: "Tourico Holidays", value: "ORD80" },
    { key: 3581, text: "Mermaid Travel Services", value: "KVA100EN" },
    { key: 2758, text: "Sidetours Incoming Services", value: "MAH70" },
    { key: 2823, text: "hotelbeds Cuba", value: "HTBVRA" },
    { key: 2833, text: "Hotelbeds_Jamaica", value: "HTBJA" },
    { key: 2860, text: "Hotelbeds_Barbados", value: "HTBBGI" },
    { key: 3196, text: "Hotelbeds", value: "HTBCV" },
    { key: 3600, text: "MTS Santorini", value: "JTR90ES" },
    { key: 3489, text: "Holiday Moments", value: "AUH80EN" },
    { key: 2830, text: "Hotelbeds_Kenia", value: "HTBEAK" },
    { key: 3703, text: "LPA Viajes Canarias Europa (tel.)", value: "LPA72EN" },
    { key: 3175, text: "John Keells Maldivian Resorts ", value: "MLE50" },
    { key: 3185, text: "Melo Travel", value: "PDL70" },
    { key: 3254, text: "Mermaid Travel Services", value: "KVA100" },
    { key: 3176, text: "Club Turavia S.A. De C.V. / Hotelbeds", value: "HTBCUN" },
    { key: 2828, text: "Club Turavia S.A. De C.V. / Hotelbeds", value: "HTBCU" },
    { key: 3183, text: "Club Turavia s.a. de c.v. / Hotelbeds", value: "HTBBRA" },
    { key: 3144, text: "PAID BY Tourico Holiday, INC.", value: "VCE72" },
    { key: 2841, text: "Hotelbeds Dominicana", value: "HTBDR" },
    { key: 2797, text: "Viajes Sidetours (telef.RL)", value: "AGP71" },
    { key: 2712, text: "VIAJES SIDETOURS", value: "XRY70" },
    { key: 3582, text: "Mermaid Travel Services", value: "KVA100ES" },
    { key: 2787, text: "Walkers Tours", value: "CMB70" },
    { key: 3612, text: "Viajes Sidetours (telef.RL)", value: "LEI71FR" },
    { key: 3480, text: "MTS Chalkidiki", value: "SKG72FR" },
    { key: 3134, text: "Walkers Tours", value: "CMB72" },
    { key: 3190, text: "Asian Adventures Travel Management Company ( PVT ) Limited", value: "MLE80" },
    { key: 3615, text: "VIAJES SIDETOURS", value: "XRY70EN" },
    { key: 3203, text: "Welcome Incoming Service", value: "CUN80" },
    { key: 2853, text: "HOTELBEDS S.L.U. _ DE", value: "HTBMLE" },
    { key: 3199, text: "Business Serenity Ltd.", value: "CUR40" },
    { key: 3491, text: "Holiday Moments", value: "AUH80FR" },
    { key: 3583, text: "Mermaid Travel Services", value: "KVA100FR" },
    { key: 3206, text: "Funbini Taber Tours Curaçao", value: "CUR100" },
    { key: 3490, text: "Holiday Moments", value: "AUH80ES" },
    { key: 3202, text: "Welcome Incoming Service", value: "PUJ60" },
    { key: 3616, text: "VIAJES SIDETOURS", value: "XRY70ES" },
    { key: 3212, text: "hotelbeds NY", value: "JFK72" },
    { key: 3211, text: "Welcome Incoming Service", value: "LRM60" },
    { key: 3702, text: "FUE Viajes Canarias Europa", value: "FUE72IT" },
    { key: 3512, text: "Sidetours Incoming Services", value: "IBZ70EN" },
    { key: 3518, text: "Sidetours Incoming Services", value: "IBZ72ES" },
    { key: 3574, text: "TFS VIAJES CANARIAS EUROPA ", value: "TFS70ES" },
    { key: 3584, text: "Cretan Holidays", value: "ZTH100EN" },
    { key: 3573, text: "TFS VIAJES CANARIAS EUROPA ", value: "TFS70FR" },
    { key: 3618, text: "VIAJES SIDETOURS", value: "XRY70FR" },
    { key: 3330, text: "MTS Globe ", value: "HRG70" },
    { key: 3375, text: "Acampora Travel", value: "NAP711" },
    { key: 3333, text: "Acampora Travel", value: "NAP710" },
    { key: 3585, text: "Cretan Holidays", value: "ZTH100FR" },
    { key: 2795, text: "TFS VIAJES CANARIAS EUROPA ", value: "TFS71" },
    { key: 3532, text: "Acampora", value: "FCO72FR" },
    { key: 3586, text: "Cretan Holidays", value: "ZTH100ES" },
    { key: 3587, text: "CRETAN HOLIDAYS", value: "RHO100EN" },
    { key: 3704, text: "LPA Viajes Canarias Europa (tel.)", value: "LPA72FR" },
    { key: 3602, text: "Viajes Sidetours Malaga", value: "LEI70EN" },
    { key: 3545, text: "Viajes Sidetours (telef.RL)", value: "AGP71FR" },
    { key: 3553, text: "CRETAN HOLIDAYS", value: "HER70FR" },
    { key: 3407, text: "Acampora Travel", value: "OLB70IT" },
    { key: 2755, text: "FUE Viajes Canarias Europa", value: "FUE70" },
    { key: 3554, text: "FUE Viajes Canarias Europa", value: "FUE70FR" },
    { key: 3387, text: "MTS Chalkidiki", value: "SKG72EN" },
    { key: 3561, text: "LPA Viajes Canarias Europa", value: "LPA70EN" },
    { key: 3141, text: "Sidetours Incoming Services", value: "MAH71" },
    { key: 3404, text: "MTS Chalkidiki", value: "SKG72IT" },
    { key: 3599, text: "MTS Santorini", value: "JTR90EN" },
    { key: 2794, text: "ACE Canarias Europa telefonisch", value: "ACE71" },
    { key: 3471, text: "MTS Globe AYT", value: "AYT81" },
    { key: 3603, text: "Viajes Sidetours Malaga", value: "LEI70ES" },
    { key: 3705, text: "LPA Viajes Canarias Europa (tel.)", value: "LPA72ES" },
    { key: 3270, text: "BLANDY TOURISM SERVICES", value: "FNC80" },
    { key: 3706, text: "LPA Viajes Canarias Europa (tel.)", value: "LPA72IT" },
    { key: 3609, text: "Viajes Sidetours (telef.RL)", value: "LEI71EN" },
    { key: 2118, text: "BLANDY TOURISM SERVICES", value: "FNC70" },
    { key: 3388, text: "MTS Chalkidiki", value: "SKG72ES" },
    { key: 3610, text: "Viajes Sidetours (telef.RL)", value: "LEI71ES" },
    { key: 3707, text: "MTS Athens", value: "ATH90EN" },
    { key: 3557, text: "ACE Canarias Europa", value: "ACE70EN" },
    { key: 3709, text: "MTS Athens", value: "ATH90ES" },
    { key: 3708, text: "MTS Athens", value: "ATH90FR" },
    { key: 3621, text: "Viajes Sidetours PT telefon. Reiseleitung", value: "LIS71EN" },
    { key: 3701, text: "FUE Viajes Canarias Europa", value: "FUE72EN" },
    { key: 3725, text: "MTS Rhodos", value: "RHO72" },
    { key: 3569, text: "Robert Arrigo & Sons Ltd. ", value: "MLA70FR" },
    { key: 3622, text: "Viajes Sidetours PT telefon. Reiseleitung", value: "LIS71ES" },
    { key: 3710, text: "MTS Athens", value: "ATH90IT" },
    { key: 3627, text: "Viajes Sidetours PT telefon. Reiseleitung", value: "LIS71FR" },
    { key: 3279, text: "MTS Chalkidiki", value: "SKG72" },
    { key: 3715, text: "Sidetours Incoming Services", value: "MAH70FR" },
    { key: 3630, text: "Viajes Sidetours Portugal", value: "FAO71EN" },
    { key: 3577, text: "TFN VIAJES CANARIAS EUROPA", value: "TFN70ES" },
    { key: 3631, text: "Viajes Sidetours Portugal", value: "FAO71ES" },
    { key: 3576, text: "TFN VIAJES CANARIAS EUROPA", value: "TFN70FR" },
    { key: 3633, text: "Viajes Sidetours Portugal", value: "FAO71FR" },
    { key: 3636, text: "Viajes Sidetours Portugal telef.Reiseleitung", value: "FAO80EN" },
    { key: 3637, text: "Viajes Sidetours Portugal telef.Reiseleitung", value: "FAO80ES" },
    { key: 3197, text: "MTS Santorini", value: "JTR90" },
    { key: 3639, text: "Viajes Sidetours Portugal telef.Reiseleitung", value: "FAO80FR" },
    { key: 2807, text: "CRETAN HOLIDAYS ", value: "HER72" },
    { key: 2657, text: "TFS VIAJES CANARIAS EUROPA ", value: "TFS70" },
    { key: 3642, text: "BLANDY TOURISM SERVICES", value: "FNC70EN" },
    { key: 3643, text: "BLANDY TOURISM SERVICES", value: "FNC70ES" },
    { key: 3645, text: "BLANDY TOURISM SERVICES", value: "FNC70FR" },
    { key: 3648, text: "BLANDY TOURISM SERVICES", value: "FNC80EN" },
    { key: 3712, text: "Sidetours Incoming Services", value: "MAH71FR" },
    { key: 3572, text: "TFS VIAJES CANARIAS EUROPA ", value: "TFS70EN" },
    { key: 3649, text: "BLANDY TOURISM SERVICES", value: "FNC80ES" },
    { key: 3713, text: "Sidetours Incoming Services", value: "MAH71ES" },
    { key: 2796, text: "TFN VIAJES CANARIAS EUROPA ", value: "TFN71" },
    { key: 3255, text: "Cretan Holidays", value: "ZTH100" },
    { key: 3391, text: "Acampora Travel", value: "NAP71ES" },
    { key: 3654, text: "MTS Globe AYT", value: "AYT80EN" },
    { key: 3655, text: "MTS Globe AYT", value: "AYT80ES" },
    { key: 3651, text: "BLANDY TOURISM SERVICES", value: "FNC80FR" },
    { key: 3714, text: "Sidetours Incoming Services", value: "MAH70ES" },
    { key: 2850, text: "Sidetours Incoming Services", value: "PMI90" },
    { key: 3424, text: "MTS Zakynthos Kefalonia", value: "EFL70" },
    { key: 3263, text: "MTS Skiathos", value: "JSI90" },
    { key: 3657, text: "MTS Globe AYT", value: "AYT80FR" },
    { key: 2466, text: "Sidetours Incoming Services", value: "PMI70" },
    { key: 3660, text: "MTS Globe AYT", value: "AYT81EN" },
    { key: 3723, text: "Albania DMC Balkan Tour Operator   ", value: "TIA01" },
    { key: 3734, text: "Grand Park Kodhipparu", value: "MLE40" },
    { key: 3661, text: "MTS Globe AYT", value: "AYT81ES" },
    { key: 3503, text: "Sidetours Incoming Services", value: "PMI70FR" },
    { key: 3728, text: "TRAVEL PARTNER REISEN (Prag)", value: "PRG72" },
    { key: 3663, text: "MTS Globe AYT", value: "AYT81FR" },
    { key: 3666, text: "MTS Globe AYT", value: "AYT82EN" },
    { key: 3520, text: "Acampora", value: "FCO72EN" },
    { key: 3667, text: "MTS Globe AYT", value: "AYT82ES" },
    { key: 2643, text: "TFN VIAJES CANARIAS EUROPA", value: "TFN70" },
    { key: 3472, text: "MTS Globe AYT", value: "AYT82" },
    { key: 3475, text: "MTS Globe AYT", value: "ADB80" },
    { key: 3669, text: "MTS Globe AYT", value: "AYT82FR" },
    { key: 3575, text: "TFN VIAJES CANARIAS EUROPA", value: "TFN70EN" },
    { key: 3672, text: "Travco Travel Company", value: "HRG60EN" },
    { key: 3389, text: "Acampora Travel", value: "NAP71EN" },
    { key: 2817, text: "SPC VIAJES CANARIAS EUROPA telefonisch", value: "SPC72" },
    { key: 3735, text: "World2Meet", value: "PUJ20" },
    { key: 3406, text: "Acampora Travel", value: "OLB70ES" },
    { key: 3678, text: "Travco Travel Company", value: "RMF60EN" },
    { key: 3675, text: "Travco Travel Company", value: "HRG60FR" },
    { key: 3513, text: "Sidetours Incoming Services", value: "IBZ70ES" },
    { key: 3673, text: "Travco Travel Company", value: "HRG60ES" },
    { key: 3578, text: "SPC VIAJES CANARIAS EUROPA", value: "SPC70EN" },
    { key: 3376, text: "Acampora Travel", value: "NAP712" },
    { key: 3517, text: "Sidetours Incoming Services", value: "IBZ72EN" },
    { key: 3732, text: "MTS Teneriffa/La Gomera", value: "TFS80" },
    { key: 3420, text: "Acampora Travel", value: "NAP713" },
    { key: 3681, text: "Travco Travel Company", value: "RMF60FR" },
    { key: 3155, text: "Sidetours Incoming Services", value: "IBZ72" },
    { key: 3733, text: "MTS La Palma", value: "SPC80" },
    { key: 3679, text: "Travco Travel Company", value: "RMF60ES" },
    { key: 3684, text: "Travco Travel Company", value: "SSH60EN" },
    { key: 3423, text: "Acampora Travel", value: "NAP715" },
    { key: 3528, text: "Acampora Travel", value: "OLB70FR" },
    { key: 3685, text: "Travco Travel Company", value: "SSH60ES" },
    { key: 3285, text: "Cretan Holidays Destinations Management", value: "CFU80" },
    { key: 3730, text: "MTS Gran Canaria", value: "LPA80" },
    { key: 3687, text: "Travco Travel Company", value: "SSH60FR" },
    { key: 3523, text: "Acampora", value: "FCO72ES" },
    { key: 3417, text: "MTS Globe ", value: "LCA70EN" },
    { key: 3405, text: "Acampora Travel", value: "OLB70EN" },
    { key: 3408, text: "Travco Travel Company", value: "HRG60" },
    { key: 3731, text: "MTS Lanzarote", value: "ACE80" },
    { key: 3397, text: "Acampora Travel", value: "OLB70" },
    { key: 3481, text: "Cretan Holidays Destinations Management", value: "CFU80FR" },
    { key: 2777, text: "W2M Marocco", value: "RAK80" },
    { key: 3738, text: "W2M Marocco", value: "AGA80" }
  ];


export const optionsCategory = [
    { value: "1+", key: "1+", text: "1+"  },
    { value: "1",  key: "1",  text: "1*"   },
    { value: "2",  key: "2",  text: "2*"   },
    { value: "3",  key: "3",  text: "3*"   },
    { value: "4",  key: "4",  text: "4*"   },
    { value: "5",  key: "5",  text: "5*"   },
    { value: "1S", key: "1S", text: "1 Schlüssel" },
    { value: "2+", key: "2+", text: "2*+" },
    { value: "3+", key: "3+", text: "3*+" },
    { value: "4+", key: "4+", text: "4*+" },
    { value: "5+", key: "5+", text: "5*+" }
  ];


export const optionsCategoryTO = [
    { value: "*",  key: "*",  text: "1*" },
    { value: "2*", key: "2*", text: "2*" },
    { value: "2+", key: "2+", text: "2*+" },
    { value: "3*", key: "3*", text: "3*" },
    { value: "3+", key: "3+", text: "3*+" },
    { value: "4*", key: "4*", text: "4*" },
    { value: "4+", key: "4+", text: "4*+" },
    { value: "5*", key: "5*", text: "5*" },
    { value: "5+", key: "5+", text: "5*+" },
    { value: "6*", key: "6*", text: "6*" },
  ];

export const optionsHoteltype = [
    { key: 1,  value: 1,  text: "Aparthotel" },
	  { key: 2,  value: 2,  text: "Appartements" },
	  { key: 41, value: 41, text: "Guest House" },
	  { key: 4,  value: 4,  text: "Bungalows" },
	  { key: 6,  value: 6,  text: "Club" },
	  { key: 7,  value: 7,  text: "Clubhotel" },
	  { key: 8,  value: 8,  text: "Ferienanlage" },
	  { key: 12, value: 12, text: "Ferienwohnung" },
	  { key: 15, value: 15, text: "Hotel" },
	  { key: 19, value: 19, text: "Pension" },
	  { key: 21, value: 21, text: "Resort" },
	  { key: 31, value: 31, text: "Finca" },
	  { key: 32, value: 32, text: "Gasthof" },
	  { key: 39, value: 39, text: "Hostal" },
	  { key: 40, value: 40, text: "Studios" }
  ];


export const optionsCurrency = [
    { key: 2,   value:  2,  code: 'MTL', text: 'Maltesische Lira' },
    { key: 6,   value:  6,  code: 'TND', text: 'Tunesischer Dinar' },
    { key: 14,  value:	14, code: 'RUB', text: 'Russischer Rubel' },
    { key: 15,  value:	15, code: 'THB', text: 'Thailand' },
    { key: 5,   value:  5,  code: 'USD', text: 'US-Dollar' },
    { key: 17,  value:	17, code: 'TL',  text: 'Yeni Türk Lirasi' },
    { key: 4,   value:  4,  code: 'EUR', text: 'Euro' },
    { key: 19,  value:	19, code: 'EUR', text: 'Euro steuerfrei' },
    { key: 20,  value:	20, code: 'MAD', text: 'MAROKKANISCHER DIRHAM' },
    { key: 21,  value:	21, code: 'DKK', text: 'DAENISCHE KRONEN' },
    { key: 22,  value:	22, code: 'SEK', text: 'SCHWEDISCHE KRONEN' },
    { key: 23,  value:	23, code: 'ZAR', text: 'Südafrikanische Rand' },
    { key: 1,   value:  1,  code: 'CHF', text: 'Schweizer Franken' },
    { key: 24,  value:	24, code: 'AED', text: 'Dirham VAE' },
    { key: 25,  value:	25, code: 'OMR', text: 'Omani Rial' },
    { key: 26,  value:	26, code: 'MYR', text: 'Malaysischer Ringgit' },
    { key: 27,  value:	27, code: 'AUD', text: 'Australischer Dollar' },
    { key: 28,  value:	28, code: 'SGD', text: 'Singapur Dollar' },
    { key: 29,  value:	29, code: 'VND', text: 'Vietnamese Dong' },
    { key: 30,  value:	30, code: 'CAD', text: 'Kanadischer Dollar' },
    { key: 31,  value:	31, code: 'RMB', text: 'Chinesischer Renminbi' },
    { key: 16,  value:	16, code: 'USD', text: 'US-Dollar' },
    { key: 18,  value:	18, code: 'GBP', text: 'Britische Pfund' },
    { key: 32,  value:	32, code: 'ISK', text: 'Isländische Kronen' },
    { key: 33,  value:	33, code: 'NAD', text: 'Namibia-Dollar' },
  ];


  export const optionsKontingent = [
    { value: "X", key: "X", text: "Grundkontingent" },
    { value: "T", key: "T", text: "Teilkontingent" },
    { value: "K", key: "K", text: "Maximal-Teilkontingent" },
  ]


  export const optionsRoom = [
    { key: 1,  text: "APPARTEMENT", value: "AB" },
    { key: 2,  text: "BUNGALOW", value: "BB" },
    { key: 3,  text: "DOPPELZIMMER", value: "DB" },
    { key: 4,  text: "EINZELZIMMER", value: "EB" },
    { key: 5,  text: "FINCA", value: "FB" },
    { key: 6,  text: "KOMFORT-ZIMMER", value: "GB" },
    { key: 7,  text: "FAMILIEN-ZIMMER", value: "HB" },
    { key: 8,  text: "JUNIORSUITE", value: "IB" },
    { key: 9,  text: "MEERBLICK-ZIMMER", value: "JB" },
    { key: 10, text: "SUITE", value: "KB" },
    { key: 11, text: "DELUXE-ZIMMER", value: "LB" },
    { key: 12, text: "EINZEL/MEERBLICK", value: "NB" },
    { key: 13, text: "EINZEL MIT KIND", value: "OB" },
    { key: 14, text: "EINZELBETT IM MEHRBETTZIMMER", value: "PB" },
    { key: 15, text: "CLUB-ZIMMER", value: "QB" },
    { key: 16, text: "FERIENHAUS", value: "RB" },
    { key: 17, text: "STUDIO", value: "SB" },
    { key: 18, text: "DREIBETT", value: "TB" },
    { key: 19, text: "SUPERIOR", value: "UB" },
    { key: 20, text: "VILLA", value: "VB" },
    { key: 21, text: "WASSERBUNGALOW", value: "WB" },
    { key: 22, text: "AUSSENKABINE", value: "XB" },
    { key: 23, text: "INNENKABINE", value: "YB" },
    { key: 24, text: "PROMOTIONZIMMER", value: "ZB" },
    { key: 25, text: "FERIENWOHNUNG", value: "2B" },
    { key: 26, text: "DZ ZUR ALLEINBENUTZUNG", value: "3B" },
    { key: 27, text: "CHALET", value: "4B" },
    { key: 28, text: "APP./2 SCHLAFZIMMER", value: "6B" },
    { key: 29, text: "FAM.-ZIM./2 SCHLAFZIMMER", value: "8B" },
    { key: 30, text: "BUDGET-ZIMMER", value: "9B" },
    { key: 31, text: "DZ/SEITLICHER MEERBLICK", value: "5B" },
    { key: 32, text: "APPARTEMENT/MEERBLICK", value: "MB" },
    { key: 33, text: "Mietwagen", value: "7B" }
  ]


  export const optionsBoard = [
    { key: 4, value: "U", text: "Übernachtung" },
    { key: 2, value: "F", text: "Frühstück" },
    { key: 3, value: "H", text: "Halbpension" },
    { key: 11, value: "H+", text: "Halbpension plus" },
    { key: 8, value: "V", text: "Vollpension" },
    { key: 10, value: "A", text: "All Inclusive" },
    { key: 12, value: "A+", text: "All Inklusive plus" }
  ]


  export const optionsChildren = [
    { key: 5, value: 5, text: "alle Kinder" },
    { key: 1, value: 1, text: "1. Kind" },
    { key: 2, value: 2, text: "2. Kind" },
    { key: 3, value: 3, text: "3. Kind" },
    { key: 4, value: 4, text: "4. Kind" },
  ]


  export const optionsLockedOccupancies = [
    { key:  1, value: "1+1", text: "1+1" },
    { key:  2, value: "1+2", text: "1+2" },
    { key:  3, value: "1+3", text: "1+3" },
    { key:  4, value: "1+4", text: "1+4" },
    { key:  5, value: "2+1", text: "2+1" },
    { key:  6, value: "2+2", text: "2+2" },
    { key:  7, value: "2+3", text: "2+3" },
    { key:  8, value: "2+4", text: "2+4" },
    { key:  9, value: "3+1", text: "3+1" },
    { key: 10, value: "3+2", text: "3+2" },
    { key: 11, value: "3+3", text: "3+3" },
    { key: 12, value: "3+4", text: "3+4" },
    { key: 13, value: "4+1", text: "4+1" },
    { key: 14, value: "4+2", text: "4+2" },
    { key: 15, value: "4+3", text: "4+3" },
    { key: 16, value: "4+4", text: "4+4" },
    { key: 17, value: "5+1", text: "5+1" },
    { key: 18, value: "5+2", text: "5+2" },
    { key: 19, value: "5+3", text: "5+3" },
    { key: 20, value: "5+4", text: "5+4" },
    { key: 21, value: "6+1", text: "6+1" },
    { key: 22, value: "6+2", text: "6+2" },
    { key: 23, value: "6+3", text: "6+3" },
    { key: 24, value: "6+4", text: "6+4" }
  ]


  export const optionsInfants = [
    { key: 1, value: "N", text: "keine Infants buchbar" },
    { key: 2, value: "M", text: "Total max gilt inkl. Infants" },
    { key: 3, value: "X", text: "Total max + max 1 Infant" }
  ]

  export const optionsExtraTypes = {
    'Contract': [
      { key: 1, text: "Early Booking Special",  value: 18 },
      { key: 2, text: "Free Night Special",     value: 11 },
      { key: 3, text: "Special Reduction",      value: 17 },
      { key: 4, text: "Additional Costs",       value: 19 },
      { key: 5, text: "Special Supplement",     value: 21 }
    ],
    'Additional': [
      { key: 1, text: "Early Booking Special",  value: 14 },
      { key: 2, text: "Free Night Special",     value: 1 },
      { key: 3, text: "Special Rate",           value: 12 },
      { key: 4, text: "Special Reduction",      value: 13 },
      { key: 5, text: "Additional Costs",       value: 15 },
      { key: 6, text: "Special Supplement",     value: 20 }
    ]
  }